import React, { useEffect } from 'react';

import ExportModalWithStoresAndPeriod from '@commons/ExportModalWithStoresAndPeriod';

import { usePeriodDatePickerState } from '@hooks/usePeriodDatePickerState';

import { ExportModalContainer } from './styledComponents';

/**
 * Export generic modal for food cost by store and by category
 *
 * @param {Object} props
 * @param {string} props.maxFutureDate - Maximum future date
 * @param {string} props.initialStartDate - Initial start date
 * @param {string} props.initialEndDate - Initial end date
 * @param {Array} props.exportGroups - List of groups to export
 * @param {Array} props.exportSelectedGroups - List of selected groups
 * @param {Function} props.setExportSelectedGroups - Function to set the selected groups
 * @param {Array} props.exportStores - List of stores to export
 * @param {Array} props.exportSelectedStores - List of selected stores
 * @param {Function} props.setExportSelectedStores - Function to set the selected stores
 * @param {Object} props.setExportPeriod - Function to set the export period
 * @param {string} props.clientStoreName - Naming of "store" for the client
 * @param {string} props.defaultTimezone - Default timezone
 */
export const AnalyticsBySupplierProductWithGroupsExportModal = (props) => {
  const {
    maxFutureDate,
    initialStartDate,
    initialEndDate,
    exportGroups,
    exportSelectedGroups,
    setExportSelectedGroups,
    exportStores,
    exportSelectedStores,
    setExportSelectedStores,
    setExportPeriod,
    clientStoreName,
    defaultTimezone,
  } = props;

  const periodPickerState = usePeriodDatePickerState(
    initialStartDate,
    initialEndDate,
    defaultTimezone,
  );

  useEffect(() => {
    if (!periodPickerState.startDate || !periodPickerState.endDate) {
      return;
    }

    setExportPeriod({ startDate: periodPickerState.startDate, endDate: periodPickerState.endDate });
  }, [periodPickerState.startDate, periodPickerState.endDate]);

  return (
    <ExportModalContainer>
      <ExportModalWithStoresAndPeriod
        clientStoreName={clientStoreName}
        defaultTimezone={defaultTimezone}
        filteredStores={exportStores}
        groups={exportGroups}
        maxFutureDate={maxFutureDate}
        periodPickerState={periodPickerState}
        selectedGroups={exportSelectedGroups}
        selectedStores={exportSelectedStores}
        setSelectedGroups={setExportSelectedGroups}
        setSelectedStores={setExportSelectedStores}
      />
    </ExportModalContainer>
  );
};

export default AnalyticsBySupplierProductWithGroupsExportModal;
